import { Link } from "gatsby"
import React from "react"
import { Target, getBgColor, getBgImage } from "../../../utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhone } from "@fortawesome/free-solid-svg-icons"

type Props = {
  target: Target
  tel: string
}

const Contact: React.VFC<Props> = ({ target, tel }) => {
  return (
    <div
      className={`${getBgImage(
        target
      )} p-7 md:p-10 md:flex mt-24 text-center md:text-left rounded-md`}
    >
      <div>
        <div className="text-2xl font-kiwiMaru md:text-3xl">
          お気軽にご見学ください
        </div>
        <div className="mt-4">
          ご見学やご相談・入園申込については随時、受付中です。
        </div>
        <div>お気軽にご相談ください。</div>
      </div>
      <div className="m-auto">
        <div className="flex items-center justify-center mt-8 md:mt-0">
          <FontAwesomeIcon icon={faPhone} size="lg" color="dimgray" />
          <a href={`tel:${tel}`} className="block ml-3 text-2xl font-kiwiMaru">
            {tel}
          </a>
        </div>
        <Link
          to={`/${target}/contact`}
          className={`block px-5 py-3 mx-auto mt-7 text-white rounded font-kiwiMaru w-fit ${getBgColor(
            target
          )}`}
        >
          ご見学・ご相談
        </Link>
      </div>
    </div>
  )
}

export default Contact
